/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
import React from 'react';
import PropTypes from 'prop-types';

var SymbolDiamond = function SymbolDiamond(_ref) {
    var x = _ref.x,
        y = _ref.y,
        size = _ref.size,
        fill = _ref.fill;

    return React.createElement(
        'g',
        { transform: 'translate(' + x + ',' + y + ')' },
        React.createElement('path', {
            fill: fill,
            d: '\n                    M' + size / 2 + ' 0\n                    L' + size * 0.8 + ' ' + size / 2 + '\n                    L' + size / 2 + ' ' + size + '\n                    L' + size * 0.2 + ' ' + size / 2 + '\n                    L' + size / 2 + ' 0\n                '
        })
    );
};

SymbolDiamond.propTypes = {
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    size: PropTypes.number.isRequired,
    fill: PropTypes.string.isRequired
};

export default SymbolDiamond;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nivo/legends/es/svg/symbols/SymbolDiamond.js
// module id = 1500
// module chunks = 0